import Pack from '@/modules-v2/pack/views/index';

const order = [
  {
    path: '/pack',
    name: 'Pack',
    component: Pack,
    meta: {
      title: 'Pack',
      requiresAuth: true,
    },
  },
];

export default order;
